import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import useClientTabMissingFields from '@/containers/SubscriptionFormPageNew/SubscriptionForm/ClientTabStatus/useClientTabMissingFields'

const HouseType = () => {
  const { t, houseTypeOptionsArray, housingType, updateAddress, errors, houseTypeOptions, optionalResidenceFields } =
    useAddress()
  const isMissing = useClientTabMissingFields()

  if (!houseTypeOptionsArray) {
    return null
  }

  if (Object.entries(houseTypeOptions).length > 3) {
    return (
      <SDFormControl plainLabel error={getError('housingType', errors)}>
        <SDSelect
          label={() => (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  (optionalResidenceFields ? '' : mandatoryTag) + t('subscriptionForm:address_module.housing_type'),
              }}
            />
          )}
          placeholder='Select'
          selectedValue={housingType ?? ''}
          missing={isMissing('housingType')}
          optionsList={houseTypeOptions}
          onChangeHandler={option =>
            updateAddress({
              housingType: option.value[0]?.id ?? '',
            })
          }
        />
      </SDFormControl>
    )
  }

  return (
    <SDFormControl
      plainLabel
      label={() => (
        <div
          dangerouslySetInnerHTML={{
            __html: (optionalResidenceFields ? '' : mandatoryTag) + t('subscriptionForm:address_module.housing_type'),
          }}
        />
      )}
      error={getError('housingType', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => updateAddress({ housingType: value })}
        options={houseTypeOptionsArray}
        selectedValue={housingType}
        missing={isMissing('housingType')}
        newTranslations={true}
        translationsPath='subscriptionForm:address_module.house_types.'
      />
    </SDFormControl>
  )
}

export default HouseType
